import { render, staticRenderFns } from "./SubscriptionButton.vue?vue&type=template&id=0d77b80a"
import script from "./SubscriptionButton.vue?vue&type=script&lang=js"
export * from "./SubscriptionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectLink: require('D:/private/personal-finance/src/components/Common/ProjectLink.vue').default})
